import React, { useState, useEffect } from "react";
import Header from "./../../components/Header";
import "./Story.sass";
import Hero from "./Hero";
import Main from "./Main";
import Dangers from "./Dangers";
import Night from "./Night";
import Demiurge from "./Demiurge";
import Join from "./Join";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function Story() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [headerBg, setHeaderBg] = useState(
    "linear-gradient(0deg, rgba(16, 2, 36, 0.67) 0%, rgba(16, 2, 36, 0.67) 100%), url(/images/story-header-mobile-bg.png)"
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    if (windowDimensions.width < 576) {
      setHeaderBg(
        "linear-gradient(0deg, rgba(16, 2, 36, 0.67) 0%, rgba(16, 2, 36, 0.67) 100%), url(/images/story-header-mobile-bg.png)"
      );
    } else {
      setHeaderBg(
        "linear-gradient(0deg, rgba(14, 25, 40, 0.83) 0%, rgba(14, 25, 40, 0.83) 100%)"
      );
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions.width]);

  return (
    <div className="story">
      <Header bg={headerBg} />
      <Hero />
      <Main />
      <Dangers />
      <Night />
      <Demiurge />
      <Join />
    </div>
  );
}
